import type { PluginServicePlugins } from 'types/editorPlugins';

export const doubleClickPlugin: PluginServicePlugins.DoubleClickPlugin =
  () => () => {};
